import { a as s, b as o, c as u, d as i, e as c } from "../helpers-D3WySQMf.js";
var h = function(t) {
  function r(n, e) {
    var a;
    return i(this, r), (a = c(this, r, [n])).name = "SyntheticChangeError", a.cause = e, a;
  }
  return s(r, t), o(r);
}(u(Error));
export {
  h as default
};
//# sourceMappingURL=SyntheticChangeError.js.map
